import ComponentHeader from '../ComponentHeader';

const Paragraph = (props) => {
	const { data, style } = props;
	let classNames = 'static';
	if (data.bold) {
		classNames += ' bold';
	}
	if (data.italic) {
		classNames += ' italic';
	}

	let baseClasses = 'SortableItem rfb-item';
	if (data.pageBreakBefore) {
		baseClasses += ' alwaysbreak';
	}

	let fieldName = data?.field_name || `${data.group_name}_${data.id.toLowerCase()}`;

	return (
		<div name={fieldName.toLowerCase()} style={{ ...style }} className={baseClasses}>
			<ComponentHeader {...props} />
			<p className={classNames} dangerouslySetInnerHTML={{ __html: data.content }} />
		</div>
	);
};

export default Paragraph;
